var itBlock = document.getElementsByClassName('trip_itinerary_section');
var sections = document.getElementsByClassName('itinerary--item');
var sectionDetails = document.getElementsByClassName('itinerary-details--item');
var sectionDetailsArray = [].slice.call(sectionDetails);

if (itBlock.length !== 0) {
    var sticky = itBlock[0].offsetTop;
    var notSticky = itBlock[0].scrollHeight;
    var bottom = notSticky + sticky;
    var windowScrollHeight = itBlock[0].scrollHeight;

    var menu = document.getElementsByClassName('trip_itinerary--left');
    var right = document.getElementsByClassName('trip_itinerary--right');

    // window.onscroll = function() {itineraryBlockScroll()};
    window.addEventListener('scroll', itineraryBlockScroll);
}

function itineraryBlockScroll() {
    var menuContent = document.getElementsByClassName('trip_itinerart--left-menu')


    var heightMenu = menuContent[0].offsetHeight;

    if ((window.pageYOffset + 90) >= sticky) {
        itBlock[0].classList.add("sticky")
        menu[0].style.height = (heightMenu + 200) + 'px';
    } else {
        itBlock[0].classList.remove("sticky");
    }

    // for (var o = 0; o < sectionDetails.length; o++) {
        var index = 0;
        sectionDetailsArray.forEach(element => {
                if (window.pageYOffset + 191 > element.offsetTop) { // Offset is for when to change left nav active state
                    for (var i = 0; i < sectionDetailsArray.length; i++ ){
                        sections[i].classList.remove('active');
                    }
                    sections[index].classList.add('active');
                }
                index++;
        });
    // }
}

// window.onload = (event) => {

//     var imageSliders = document.querySelectorAll('.large-image-slider');
//     console.log(imageSliders);

//     for ( var i = 0; i < imageSliders.length; i++) {
//         var slides = imageSliders[i].getElementsByClassName('swiper-slide');
//         var wrapper = imageSliders[i].getElementsByClassName('swiper-wrapper');

//         for (var ii = 0; ii < wrapper.length; ii++) {
//             var img = slides[0].getElementsByTagName('img');

//             console.log(img);
//             console.log(slides[0]);

//             console.log(img[0].clientHeight);

//             wrapper[ii].style.height = img[0].clientHeight + 'px';
//         }
//     } 
// };